import { Component, OnInit } from '@angular/core';
import { onSideNavChange, animateText } from '../animations/animations';
import { SidenavService } from '../services/sidenav.service';
import { AuthService } from '../services/authservice/auth.service';
import { NavbarEventManager } from '../_common/NavbarEventManager';
import { AppMapComponent } from '../app-map.component';
import { Settings } from '../services/settings';
import { __assign } from 'tslib';

interface Page {
	link: string;
	name: string;
	icon: string;
	mouseover: string;
	id: string;
}

@Component({
	selector: 'app-left-menu',
	templateUrl: './navigation.component.html',
	styleUrls: ['./navigation.component.css'],
	animations: [onSideNavChange, animateText]
})
export class NavigationComponent implements OnInit {

	public sideNavState: boolean = false;
	public linkText: boolean = false;
	public IsAuthenticated: boolean = false;
	private showNavBar: boolean = false;
	public featurelist: Page[] = [];
	public visibleResourceSite: boolean = false;
	public pages: Page[] = this.appMap.navItems;

	constructor(private authService: AuthService, public sidenavService: SidenavService, public appMap: AppMapComponent, private navEventMgr: NavbarEventManager) {

		this.authService.isAuthenticated$.subscribe(value => { this.IsAuthenticated = value; });
		this.navEventMgr.showNavBar.subscribe((mode: any) => {
			this.showNavBar = mode;
			if (this.showNavBar === true) {
				if(Settings.getInstance().hasPrivilege('NAV_RESOURCE_SITE', "SHOW")) {
					this.visibleResourceSite = true;
				}
				this.featurelist = [];
				for (let i = 0; i < this.pages.length; i++) {
					const rec = this.pages[i];

					switch (rec.id) {
						case 'nav-home':
							if(Settings.getInstance().hasPrivilege('NAVIGATE_HOME', "EXECUTE") || Settings.getInstance().hasPrivilege('NAVIGATE_DASHBOARD', "EXECUTE")
								|| Settings.getInstance().hasPrivilege('NAVIGATE_REPORTS', "EXECUTE")) {
								this.featurelist.push(rec);
							}
							break;
						case 'nav-requests':
							if(Settings.getInstance().hasPrivilege('NAV_REQUESTS', "EXECUTE")) {
								this.featurelist.push(rec);
							}
							break;
						case 'nav-cases':
							if(Settings.getInstance().hasPrivilege('NAV_CLIENTS', "EXECUTE")||Settings.getInstance().hasPrivilege('NAV_CLIENTS', "SHOW")) {
								this.featurelist.push(rec);
							}
							break;
						case 'nav-agencies':
							if(Settings.getInstance().hasPrivilege('NAV_AGENCIES', "EXECUTE")||Settings.getInstance().hasPrivilege('NAV_AGENCIES', "SHOW")) {
								this.featurelist.push(rec);
							}
							break;
						case 'nav-settings':
							if (Settings.getInstance().hasPrivilege('NAV_SETTINGS', "EXECUTE")||Settings.getInstance().hasPrivilege('NAV_SETTINGS', "SHOW")) {
								this.featurelist.push(rec);
							}
							break;
					}
				}
				window.dispatchEvent(new Event('resize'));
			}
		});
	}

	ngOnInit() {
		if(Settings.getInstance().hasPrivilege('NAV_RESOURCE_SITE', "SHOW")) {
			this.visibleResourceSite = true;
		}
	}
	public isIcon(inp: string): boolean {

		if(String(inp).includes('_') === true ) {
			return false;
		}

		return true;
	}

	public doLaunchResourcesSite(): void {
		const URLtoLaunch= window.location.origin + '/resources';
		window.open(URLtoLaunch);
	}
}
